// Tipos de envío, tal como se los nombra al artista (al elegir) y al
// difusor (al recibirlo).
//
// El costo y el pago al difusor los decide el servidor
// (Backend/src/utils/planesEnvio.js): `amount` acá es solo informativo.
//
// El envío de 5 RC significa cosas distintas según quién lo recibe:
//   - a un blog, revista o periódico se le pide una nota editorial;
//   - a un Influencer, Youtuber o Streamer, una mención o entrevista dentro
//     de su contenido;
//   - a una estación de radio o un canal de TV, una mención o entrevista
//     dentro de su programación.
//
// Espejo en el backend: Backend/src/utils/gruposDifusor.js.

export const TIPOS_MENCION_CREADOR = ["Influencer", "Youtuber", "Streamer"];
export const TIPOS_MENCION_RADIO_TV = ["Estación de radio", "Canal de TV"];
export const TIPOS_DIFUSOR_MENCION = [
  ...TIPOS_MENCION_CREADOR,
  ...TIPOS_MENCION_RADIO_TV,
];

const normalizar = (texto) =>
  String(texto || "")
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .trim()
    .toLowerCase();

const esUnoDe = (lista, tipo) => {
  const buscado = normalizar(tipo);
  return lista.some((t) => normalizar(t) === buscado);
};

// "editorial" | "creador" | "radio_tv". Un tipo desconocido (o vacío) cuenta
// como medio editorial, como hasta ahora.
export function grupoDeDifusor(tipo) {
  if (esUnoDe(TIPOS_MENCION_CREADOR, tipo)) return "creador";
  if (esUnoDe(TIPOS_MENCION_RADIO_TV, tipo)) return "radio_tv";
  return "editorial";
}

export function esDifusorDeMencion(tipo) {
  return grupoDeDifusor(tipo) !== "editorial";
}

export const ENVIO_SOCIAL = {
  radarCoin: 1,
  amount: 1,
  nombre: "Envío Social",
  titulo: "Envío Social - Costo: 1 RC",
  descripcion:
    "Este tipo de envío es para que los difusores compartan tu canción o evento en sus redes sociales o añadir tu canción a una playlist de Spotify.",
};

export const ENVIO_EDITORIAL = {
  radarCoin: 5,
  amount: 7,
  nombre: "Envío Editorial",
  titulo: "Envío Editorial - Costo: 5 RC",
  descripcion:
    "Este tipo de envío es para solicitar una nota editorial de tu lanzamiento, evento o una entrevista.",
};

export const ENVIO_MENCION = {
  radarCoin: 5,
  amount: 7,
  nombre: "Envío de Mención",
  titulo: "Envío de Mención - Costo: 5 RC",
  descripcion:
    "Este tipo de envío es para solicitar una mención o entrevista dentro del contenido del Influencer, Youtuber o Streamer de tu lanzamiento o evento.",
};

// También es de mención, pero dentro de la programación de una estación de
// radio o un canal de TV.
export const ENVIO_MENCION_RADIO_TV = {
  radarCoin: 5,
  amount: 7,
  nombre: "Envío de Mención",
  titulo: "Envío de Mención - Costo: 5 RC",
  descripcion:
    "Este tipo de envío es para solicitar una mención o entrevista dentro del canal de radio o TV de tu lanzamiento o evento.",
};

const PLAN_5RC = {
  editorial: ENVIO_EDITORIAL,
  creador: ENVIO_MENCION,
  radio_tv: ENVIO_MENCION_RADIO_TV,
};

// Cómo se nombra cada grupo cuando una selección los mezcla.
const PARA_GRUPO = {
  editorial: "Para los medios",
  creador: "Para Influencers, Youtubers y Streamers",
  radio_tv: "Para radio y TV",
};

// El plan de un envío según sus RC y el tipo del difusor que lo recibe.
// Se busca por RC y no por monto: el pago de 5 RC pasó de 6 a 7 USD, y
// buscar por monto dejaba sin plan —y rompía la pantalla del difusor— a
// los envíos nuevos. Null si los RC no corresponden a ningún plan.
export function planDeEnvio(radarCoin, tipoDifusor) {
  const rc = Number(radarCoin);
  if (rc === 1) return ENVIO_SOCIAL;
  if (rc === 5) return PLAN_5RC[grupoDeDifusor(tipoDifusor)];
  return null;
}

// Las dos opciones del modal de envío para los difusores seleccionados. El
// plan elegido se aplica a todos a la vez, así que si la selección mezcla
// grupos (medios, creadores, radio y TV), la opción de 5 RC explica qué
// recibe cada uno.
export function opcionesDeEnvio(tiposDifusores = []) {
  const cuantos = { editorial: 0, creador: 0, radio_tv: 0 };
  tiposDifusores.forEach((tipo) => {
    cuantos[grupoDeDifusor(tipo)] += 1;
  });
  const presentes = Object.keys(cuantos).filter((g) => cuantos[g] > 0);

  let premium;
  if (presentes.length <= 1) {
    premium = PLAN_5RC[presentes[0] || "editorial"];
  } else {
    premium = {
      ...ENVIO_EDITORIAL,
      titulo: presentes.includes("editorial")
        ? "Envío Editorial o de Mención - Costo: 5 RC"
        : "Envío de Mención - Costo: 5 RC",
      detalle: presentes.map((grupo) => ({
        para: `${PARA_GRUPO[grupo]} (${cuantos[grupo]})`,
        descripcion: PLAN_5RC[grupo].descripcion,
      })),
    };
  }

  return [ENVIO_SOCIAL, premium];
}
